// extracted by mini-css-extract-plugin
export default {"tituloRotas":"LayoutRotas_tituloRotas__UGFFO","main":"LayoutRotas_main__7MxCD"};